import React, {useState, useEffect} from 'react'
import AltTextAudit from './AltTextAudit.js'

import _ from 'lodash'
import HTMLField from './HTMLField'

const SegmentEditForm = props => {

    // const step = ((props.contentData||{}).steps||[])[props.stepIndex];
    const segment = props.data;
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [activeField, setActiveField] = useState(-1);
    const [rawMode, setRawMode] = useState(false);

    const crumbPop = (howMany = 1) => {
        let temp = _.clone(breadcrumbs);
        temp.splice(temp.length - howMany, howMany)
        setBreadcrumbs(temp)
    }

    const crumbPush = (key) => {
        if(!key) return;
        let temp = _.clone(breadcrumbs)
        temp.push(key)
        setBreadcrumbs(temp)
    }

    const setValue = (propertyPath, value, obj) => {

        // https://medium.com/data-scraper-tips-tricks/safely-read-write-in-deeply-nested-objects-js-a1d9ddd168c6

        // this is a super simple parsing, you will want to make this more complex to handle correctly any path
        // it will split by the dots at first and then simply pass along the array (on next iterations)
        let properties = Array.isArray(propertyPath) ? propertyPath : propertyPath.split(".")
      
        // Not yet at the last property so keep digging
        if (properties.length > 1) {
          // The property doesn't exists OR is not an object (and so we overwritte it) so we create it
          if (!obj.hasOwnProperty(properties[0]) || typeof obj[properties[0]] !== "object") obj[properties[0]] = {}
            // We iterate.
          return setValue(properties.slice(1), value, obj[properties[0]])
            // This is the last property - the one where to set the value
        } else {
          // We set the value to the last property
          obj[properties[0]] = value
          return true // this is the end
        }
      
      }

      const getValue = (propertyPath, obj) => {
        // https://medium.com/data-scraper-tips-tricks/safely-read-write-in-deeply-nested-objects-js-a1d9ddd168c6

        // this is a super simple parsing, you will want to make this more complex to handle correctly any path
        // it will split by the dots at first and then simply pass along the array (on next iterations)
        let properties = Array.isArray(propertyPath) ? propertyPath : propertyPath.split(".")
      
        // Not yet at the last property so keep digging
        if (properties.length > 1) {
          // The property doesn't exists OR is not an object (and so we overwritte it) so we create it
          if (!obj.hasOwnProperty(properties[0]) || typeof obj[properties[0]] !== "object") obj[properties[0]] = {}
            // We iterate.
          return getValue(properties.slice(1), obj[properties[0]])
            // This is the last property - the one where to set the value
        } else if(properties.length === 1){
          return obj[properties[0]] // this is the end
        }else if(properties.length === 0){
            return obj;
        }
      
      }



    const genericInput = (data, keys, parentIsArray) => {
        let jsx = [];
        switch (typeof data) {
            case 'string':
                if(/<\/?[a-z][\s\S]*>/i.test(data)) {
                    // contains HTML
                    if(_.isEqual(keys, activeField)){
                        if(!rawMode){
                            jsx = <HTMLField val={data} onChange={(value)=> handleFormChange(keys, value)} />
                        }else{
                            jsx = <textarea type="text" value={data} onChange={(e)=>handleFormChange(keys, e.currentTarget.value)}/>

                        }
                    }else{
                        jsx = <p className={`sample`} onClick={()=>setActiveField(keys)} dangerouslySetInnerHTML={{__html:data}}></p>
                    }
                }else{
                    jsx = <input type="text" value={data} onChange={(e)=>handleFormChange(keys, e.currentTarget.value)}/>
                }
                break;
            case 'number':
                jsx = <input type="number" value={data} onChange={(e)=>handleFormChange(keys, e.currentTarget.value)}/>
                break;
            case 'boolean':
                jsx = <input type="checkbox" checked={data} onChange={(e)=>handleFormChangeCheckbox(keys)}/>
                break;
            case 'object':
                jsx = <div className={`breakout-button`} onClick={()=>crumbPush(keys[keys.length - 1])}>{`{...}`}</div>
                break;
            default:
                break;
        }
        return <tr key={JSON.stringify(keys)}>
            <td className="label">{keys[keys.length - 1]}</td>
            <td className="field">{jsx}</td>
        </tr>
    }

    const recursiveDecodeObject = (data, keys, parentIsArray = false) => {
        if(typeof data !== 'object') return <></>;
        if(!keys){
            return Object.keys(data).map((key)=>{
                let temp = _.clone(breadcrumbs);
                temp.push(key);
                return genericInput(data[key], temp, parentIsArray)
            })
        }else{
            return Object.keys(data).map((key)=>{
                let temp = _.cloneDeep(keys);
                temp.push(key);
                return genericInput(data[key], temp, parentIsArray)
            })
        }
       
    }

    const handleFormChange = (keys, value) => {
        let temp = _.cloneDeep(segment);
        if(!setValue(keys, value, temp)){
            console.log('setvalue error');
        }else{
            props.onChange(temp);
        }
    }

    const handleFormChangeCheckbox = (keys) => {
        let temp = _.cloneDeep(segment);
        if(!setValue(keys, !getValue(keys, temp), temp)){
            console.log('setvalue error');
        }else{
            props.onChange(temp);
        }
      

    }

    
    const JSONSearch = (obj, name) => {
        let result = [];
        let recur = (object, keys) => {
            if (object === null) {
                return undefined
            }
            Object.keys(object).forEach(key => {
                if(key === 'image'){
                    let temp = _.cloneDeep(object[key])
                    if(typeof object[key] === "object"){
                        temp.keys = [...keys, key]
                        result.push(temp)
                    }
                }
                else if(typeof object[key] === "object"){
                    recur(object[key], [...keys, key])
                }
            })
        }
        recur(obj, [])
        return result;
    }


    return (
        <div className="SegmentEditForm">
            <div className="editor-button" onClick={props.commitChanges}>{props.saving.message}</div>
           
            <div className={`segment`}>
                <div className={`breadcrumbs`}>
                    <div className={`crumb`}
                    onClick={()=>crumbPop(breadcrumbs.length)}>Root</div>
                    {
                        breadcrumbs.map((crumb, crumbIndex) => {
                            return <div className={`crumb`}
                            key={crumb + crumbIndex}
                            onClick={()=>crumbPop(breadcrumbs.length - 1 - crumbIndex)}>{crumb}</div>
                        })
                    }
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {recursiveDecodeObject(getValue(breadcrumbs, segment))}
                    </tbody>
                </table> 
                <div className="settings">
                    <input type="checkbox" id="rawmode" name="rawmode"
                            checked={rawMode} onChange={(e)=>{
                                setRawMode(!rawMode);
                            }}></input>
                    <label htmlFor="rawmode">Raw HTML Mode</label>
                </div>

            </div>
            { segment &&
                <AltTextAudit handleFormChange={handleFormChange} breadcrumbs={breadcrumbs} images={JSONSearch(getValue(breadcrumbs, segment), 'image')}/>
            }
            <div className="editor-button" onClick={props.commitChanges}>{props.saving.message}</div>
        </div>
    )
}

export default SegmentEditForm